import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { LoanNotesModel } from '../../cmg-1003/models/notes.model';
import { iStoreActions } from '../core/store-actions.interface';

function createInitialState(): LoanNotesModel {
  return <LoanNotesModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-loan-notes' })
export class LoanNotesDataStore extends Store<LoanNotesModel> implements iStoreActions<LoanNotesModel> {
  private _initValue: LoanNotesModel = null;
  constructor() {
    super(createInitialState());
  }

  akitaPreUpdate = (model: Readonly<LoanNotesModel>, updatedModel: LoanNotesModel) => {
    return updatedModel;
  };

  preInitialize(): void {
    this._initValue = JSON.parse(JSON.stringify(this.getValue()));
  }

  get initialValue() {
    return this._initValue;
  }
}
